var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "brand-dashboard container-fluid" },
    [
      _c("div", { staticClass: "card mb-3 brand-card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "d-flex align-items-center mb-3" }, [
            _c("div", { staticClass: "icon-circle mr-2" }, [
              _c(
                "span",
                { staticClass: "icon-inner" },
                [
                  _c("Store", { attrs: { width: "20" } }),
                  _vm._v("️\n          "),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("h5", { staticClass: "card-title mb-0" }, [
              _vm._v("\n          Brand Settings\n        "),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group mb-2" }, [
            _c("label", { staticClass: "mb-1" }, [_vm._v("Brand Name")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex align-items-center" },
              [
                _c("Multiselect", {
                  attrs: {
                    options: _vm.brands,
                    multiple: false,
                    searchable: true,
                    "track-by": "id",
                    label: "brand_name",
                    placeholder: "Choose brand...",
                    "allow-empty": false,
                    "open-direction": "auto",
                  },
                  model: {
                    value: _vm.selectedBrand,
                    callback: function ($$v) {
                      _vm.selectedBrand = $$v
                    },
                    expression: "selectedBrand",
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-teal ml-2",
                    attrs: { type: "button" },
                    on: { click: _vm.toggleAddBrand },
                  },
                  [_vm._v("\n            +\n          ")]
                ),
                _vm._v(" "),
                _vm.selectedBrand
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-danger ml-2",
                        attrs: { type: "button" },
                        on: { click: _vm.deleteBrand },
                      },
                      [_vm._v("\n            x\n          ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.addingBrand
            ? _c("div", { staticClass: "mt-2 pl-1" }, [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newBrand,
                        expression: "newBrand",
                      },
                    ],
                    staticClass: "form-control mr-2",
                    attrs: { type: "text", placeholder: "Enter new brand..." },
                    domProps: { value: _vm.newBrand },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.newBrand = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success mr-2",
                      on: { click: _vm.saveBrand },
                    },
                    [_vm._v("\n            Save\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      on: { click: _vm.cancelAddBrand },
                    },
                    [_vm._v("\n            Cancel\n          ")]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("small", { staticClass: "text-muted d-block mt-2" }, [
            _vm._v(
              "\n        Share of Shelf calculates how many products from this brand appear in top search results\n      "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card mb-3" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "d-flex align-items-center mb-3" }, [
            _c("div", { staticClass: "icon-circle mr-2" }, [
              _c(
                "span",
                { staticClass: "icon-inner" },
                [_c("TrendingUp", { attrs: { width: "20" } })],
                1
              ),
            ]),
            _vm._v(" "),
            _c("h5", { staticClass: "card-title mb-0" }, [
              _vm._v("\n          Overall Share of Shelf\n        "),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-between align-items-baseline mb-2",
            },
            [
              _c("div", { staticClass: "overall-share-main" }, [
                _c("div", { staticClass: "overall-share-value" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.overAllShare.current) +
                      "/" +
                      _vm._s(_vm.overAllShare.total) +
                      "\n          "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "overall-share-percentage text-right" },
                [
                  _c("div", { staticClass: "percentage-value" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.overAllShare.percent) +
                        "%\n          "
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "progress progress-thin mb-2" }, [
            _c("div", {
              staticClass: "progress-bar",
              style: { width: _vm.overAllShare.percent + "%" },
              attrs: { role: "progressbar" },
            }),
          ]),
          _vm._v(" "),
          _c("small", { staticClass: "text-muted d-block" }, [
            _vm._v(
              "\n        Across " +
                _vm._s(_vm.overAllShare.keywords) +
                " tracked keywords, "
            ),
            _c("strong", { staticStyle: { color: "#0b1220" } }, [
              _vm._v(_vm._s(_vm.selectedBrand?.brand_name ?? "")),
            ]),
            _vm._v(
              "\n        appears in " +
                _vm._s(_vm.overAllShare.current) +
                " out of " +
                _vm._s(_vm.overAllShare.total) +
                " top search positions\n      "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.selectedBrand
        ? _c("div", { staticClass: "card mb-3" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("h5", { staticClass: "card-title mb-3" }, [
                _vm._v("\n        Track Keywords\n      "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newKeyword,
                      expression: "newKeyword",
                    },
                  ],
                  staticClass: "form-control mr-2",
                  attrs: {
                    type: "text",
                    placeholder: "Enter keyword to track...",
                  },
                  domProps: { value: _vm.newKeyword },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.addKeyword.apply(null, arguments)
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.newKeyword = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-teal",
                    attrs: { type: "button" },
                    on: { click: _vm.addKeyword },
                  },
                  [_vm._v("\n          +\n        ")]
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedBrand
        ? _c("div", { staticClass: "card mb-3" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("h5", { staticClass: "card-title mb-3" }, [
                _vm._v("\n        Keyword Breakdown\n      "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "table-responsive" }, [
                _c("table", { staticClass: "table keyword-table mb-0" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.selectedBrand.keywords, function (row) {
                      return _c("tr", { key: row.id }, [
                        _c("td", { staticClass: "keyword-cell" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(row.keyword) +
                              "\n              "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-right" }, [
                          _c("strong", [
                            _vm._v(_vm._s(row.found_results ?? "-")),
                          ]),
                          _vm._v(
                            "/" +
                              _vm._s(row.total_results ?? "-") +
                              "\n              "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-center text-teal" }, [
                          row.found_results && row.total_results
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    (
                                      (row.found_results / row.total_results) *
                                      100
                                    ).toFixed(1)
                                  ) + "%"
                                ),
                              ])
                            : _c("span", [_vm._v("-")]),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("div", { staticClass: "progress progress-thin" }, [
                            _c("div", {
                              staticClass: "progress-bar",
                              style: {
                                width:
                                  (
                                    (row.found_results / row.total_results) *
                                    100
                                  ).toFixed(0) + "%",
                              },
                              attrs: { role: "progressbar" },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-center" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-link btn-sm text-muted p-0",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.showInfo(row)
                                },
                              },
                            },
                            [_c("Info", { attrs: { width: "14" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-link btn-sm text-muted p-0 ml-2",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.refreshKeyword(row)
                                },
                              },
                            },
                            [_c("RefreshCw", { attrs: { width: "14" } })],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-link btn-sm text-muted p-0 ml-2",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.removeKeyword(row)
                                },
                              },
                            },
                            [_c("Trash", { attrs: { width: "14" } })],
                            1
                          ),
                        ]),
                      ])
                    }),
                    0
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("ShareOfShelfKeywordModal", {
        attrs: { "keyword-id": _vm.selectedKeyword },
        model: {
          value: _vm.showStats,
          callback: function ($$v) {
            _vm.showStats = $$v
          },
          expression: "showStats",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Keyword")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [
          _vm._v("\n                Share\n              "),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [
          _vm._v("\n                Percentage\n              "),
        ]),
        _vm._v(" "),
        _c("th", [_vm._v("Visual")]),
        _vm._v(" "),
        _c("th", {
          staticClass: "text-center",
          staticStyle: { width: "100px" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }